import { AuditLog } from 'api/Clients/Types/AuditLog'

import {
  CreateNotificationContactDetailsDto,
  NotificationContactDetailsDto,
  UpdateNotificationContactDetailsDto,
} from '../../api/Notifications/Types/NotificationContactDetailsDto'
import { PageData } from '../../api/Pagination/Types'
import { ApiClient } from './ApiClient'
import { PageQuery, preparePageQueryParams } from './index'

export class NotificationsApiClient {
  constructor(private apiClient: ApiClient) {}

  getNotificationsContactDetails: (
    query?: PageQuery
  ) => Promise<PageData<NotificationContactDetailsDto[]>> = (query) => {
    return this.apiClient.get(`notifications/contact-details?${preparePageQueryParams(query)}`)
  }

  getNotificationContactDetailsById: (
    id: number
  ) => Promise<PageData<NotificationContactDetailsDto>> = (id) => {
    return this.apiClient.get(`notifications/contact-details/${id}`)
  }

  addNotificationContactDetails: (
    data: CreateNotificationContactDetailsDto
  ) => Promise<PageData<NotificationContactDetailsDto[]>> = (data) => {
    return this.apiClient.post(`notifications/contact-details`, data)
  }

  updateNotificationsContactDetails: (
    id: number,
    data: UpdateNotificationContactDetailsDto
  ) => Promise<PageData<NotificationContactDetailsDto[]>> = (id, data) => {
    return this.apiClient.put(`notifications/contact-details/${id}`, data)
  }

  getNotificationsContactDetailsEvents: (id: number) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`notifications/contact-details/${id}/events`)
  }
}
